import VoicesUsage from "../Components/Voices/Usage/VoicesUsage";

const VoicesUsagePage = () => {
  return <VoicesUsage />;
};

export default VoicesUsagePage;
